<template>
    <div>
        <div v-if="this.attachments.length > 0">
            <div class="mt-0 pt-0 mb-2">Attachments</div>
            <v-data-table :headers="getAttachmentHeaders()"                         
                            :items="attachments" 
                            :disable-pagination=true 
                            show-select
                            v-model="selected"                                      
                            item-key="key" 
                            dense 
                            hide-default-footer>

                <!--afwijkende kolommen als volgt weergeven (template tag gekoppeld aan value in headers)-->
                <template v-slot:item.conv_size="{ item }">
                    <td>{{ bytesToSize(item.size) }}</td>
                </template>                                                    
                <template v-slot:item.isloading="{ item }">
                    <td>
                        <div v-if="!item.isloading">
                            <v-btn icon small v-on:click="getPreviewFromServer(item, true)">
                                <v-icon>mdi-card-search-outline</v-icon>
                            </v-btn>
                        </div>
                        <div v-else>
                            <v-progress-circular :width="3" :size="20" color="green" indeterminate></v-progress-circular>
                        </div>
                    </td>
                </template>
            </v-data-table>
            <v-divider/>
        </div>
        <div v-else>
            <p class="subtitle">no attachments found...</p>
        </div>
    </div>                
</template>

<script>

import mxbytestosize from '@/mixins/bytestosize';

export default {    
    watch:{
        selected: {
            deep: true,
            handler(){
                this.$emit('updateData', {field: 'selected', value: this.selected});
            } 
        },
    },    
    props: {
        table: {
            type: String,
            default: ''
        },
        attachments: {
            type: Array,
            default: function() {return [];}
        },
    },
    data () {
        return {
            singleSelect: false,
            loading: false,
            selected: [],
            preview: {},
        }
    },
    mixins: [mxbytestosize],    
    methods: {
        getPreviewFromServer(item, direct_show) {
            item.isloading = true;
            this.$axios
                .post("ares/json/ares/misc/getAttachment.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getAttachment"
                    },
                    getAttachment: {
                        table: this.table,
                        attm_nr: item.attm_nr,
                    }
                })
                .then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                    } else {
                        console.log(res.data.getAttachment);
                        this.preview = res.data.getAttachment;
                        if (direct_show) {
                            this.previewFileByUrl(this.preview.url);
                        }
                    }
                })
                .finally(() => { item.isloading = false; });
        },
        previewFileByUrl(url) {
            window.open(url, '_blank');
        },
        getAttachmentHeaders() {
            return [
                { text: "", width: "1%", sortable: false },
                { text: "Description", value: "description",  width: "30%"},
                { text: "Uploaded", value: "uploaded",width: "20%"},
                { text: "Uploaded by", value: "uploadedByName",width: "20%"},
                { text: "Size", value: "conv_size", width: "15%"},
                { text: "Type", value: "extension", width: "10%"},
                { text: "", value: "isloading", width: "1%", sortable: false },
            ];
        },
    }
}
</script>

<style scoped>
    .subtitle{
       color: gray;
       font-size: 11.5px;
       font-weight: 300;       
    }
</style>